export default "__VITE_ASSET__RqEEgN3E__"